/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Fade as Hamburger } from "hamburger-react";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import logo from "../../assets/logoimage/logo.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { FaFacebook } from "react-icons/fa";

// Reusable Navigation Link Component
const NavLink = ({ to, label, activeLink, setActiveLink, isMobile }) => (
  <motion.li
    className="relative"
    initial={{ y: -100, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ delay: isMobile ? 0.175 : 0 }}
  >
    <Link
      to={to}
      className={`${
        isMobile
          ? "text-white hover:text-gray-200"
          : "text-gray-600 hover:text-gray-900"
      } ${activeLink === label ? "font-bold" : ""}`}
      onClick={() => setActiveLink(label)}
    >
      {label}
    </Link>
    {activeLink === label && !isMobile && (
      <motion.span
        className="absolute left-0 bottom-0 w-full h-[2px] bg-gray-600"
        layoutId="activeLink"
        transition={{
          type: "spring",
          stiffness: 380,
          damping: 30,
        }}
      ></motion.span>
    )}
  </motion.li>
);

const Header = () => {
  const location = useLocation(); // Get current URL
  const [activeLink, setActiveLink] = useState("HOME");
  const [isBurgerOpen, setBurgerOpen] = useState(false);

  const isMobileView = useMediaQuery({ query: "(max-width: 768px)" });

  const toggleMenu = () => {
    setBurgerOpen(!isBurgerOpen);
  };

  // Prevent scrolling when the burger menu is open
  useEffect(() => {
    document.body.style.overflow = isBurgerOpen ? "hidden" : "auto";
    return () => (document.body.style.overflow = "auto");
  }, [isBurgerOpen]);

  // Update active link on URL change
  useEffect(() => {
    const pathToLinkMap = {
      "/": "HOME",
      "/portfolio": "PORTFOLIO",
      "/contact": "CONTACT ME",
    };
    setActiveLink(pathToLinkMap[location.pathname] || "HOME");
  }, [location.pathname]);

  const navLinks = [
    { to: "/", label: "HOME" },
    { to: "/portfolio", label: "PORTFOLIO" },
    { to: "/contact", label: "CONTACT ME" },
  ];

  return (
    <header>
      <div className="fixed top-0 left-0 w-full flex justify-between items-center bg-white z-50">
        {/* Logo */}
        <div
          className={`text-3xl font-serif font-black text-gray-800 ${
            isMobileView ? "flex justify-center w-full" : "ml-5 lg:ml-16"
          }`}
        >
          <Link
            onClick={() => setActiveLink("HOME")}
            to="/"
            className="mx-auto"
          >
            <LazyLoadImage
              src={logo}
              alt="Maggie Deoduco Logo"
              className="w-72 h-auto"
              effect="blur"
              visibleByDefault={logo}
              placeholderSrc ={logo}
            />
          </Link>
        </div>

        {isMobileView ? (
          <div className="mr-5">
            <Hamburger
              toggled={isBurgerOpen}
              toggle={toggleMenu}
              size={24}
              className="mr-4"
            />
            {isBurgerOpen && (
              <nav className="absolute top-20 right-0 w-full min-h-screen bg-rose-200 bg-opacity-70 backdrop-filter backdrop-blur-xl transform transition-transform duration-500 ease-in-out">
                <ul className="flex flex-col space-y-4 py-4 mt-20 items-center font-medium text-xl">
                  {navLinks.map(({ to, label }) => (
                    <NavLink
                      key={label}
                      to={to}
                      label={label}
                      activeLink={activeLink}
                      setActiveLink={(linkName) => {
                        setActiveLink(linkName);
                        setBurgerOpen(false);
                      }}
                      isMobile={true}
                    />
                  ))}
                  {/* Facebook Icon mobile */}
                  {/* <div>
                    <a
                      href="https://www.facebook.com/HairandMakeupbyMaggieDeoduco"
                      target="_blank"
                      rel="noreferrer"
                      className="text-white transition duration-200"
                      aria-label="Facebook Page"
                    >
                      <FaFacebook size={28} />
                    </a>
                  </div> */}
                </ul>
              </nav>
            )}
          </div>
        ) : (
          <nav className="pr-20">
            <ul className="flex space-x-10">
              {navLinks.map(({ to, label }) => (
                <NavLink
                  key={label}
                  to={to}
                  label={label}
                  activeLink={activeLink}
                  setActiveLink={setActiveLink}
                  isMobile={false}
                />
              ))}
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
